import React from "react";
import { useQuickSightCostIntelligence } from "@/hooks/useCostIntelligenceReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsCostIntelligenceDashboard from "@/components/organisms/CostIntelligenceDashboard";

function CostIntelligenceReports() {
  const { embedUrl, loading, error, refetch } =  useQuickSightCostIntelligence();

  return (
    <AWSReportsTemplate
      title="AWS Cost Intelligence Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsCostIntelligenceDashboard />
    </AWSReportsTemplate>
  );
}

export default CostIntelligenceReports;
